import { render, staticRenderFns } from "./formAdd.vue?vue&type=template&id=5a317b36"
import script from "./formAdd.vue?vue&type=script&lang=js"
export * from "./formAdd.vue?vue&type=script&lang=js"
import style0 from "./formAdd.vue?vue&type=style&index=0&id=5a317b36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports